/**
 * ProspectsToggle — global "Prospects only" filter switch.
 *
 * When ON, the page scopes all leads and counts to lead_category=prospect,
 * hiding existing patients and spam/not-applicable leads. The state is owned
 * by the parent page and persisted to localStorage("global_prospects_only")
 * so it carries between the Dashboard and the Lead List.
 *
 * Controlled component: pass `value` (boolean) and `onChange(nextValue)`.
 */
const ProspectsToggle = ({ value, onChange }) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      data-spotlight="prospects-only-toggle"
      data-attr="prospects-only-toggle"
      onClick={() => onChange(!value)}
      title={
        value
          ? "Showing prospects only — patients and spam are hidden. Click to show all leads."
          : "Showing all leads. Click to show prospects only."
      }
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${
        value
          ? "bg-teal-600 text-white border-teal-600"
          : "bg-white text-gray-700 border-border hover:border-teal-300 hover:text-teal-700"
      }`}
    >
      <span className="flex items-center gap-1.5">
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L14 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 018 21v-7.586L3.293 6.707A1 1 0 013 6V4z"
          />
        </svg>
        Prospects only
      </span>
      {/* Switch track */}
      <span
        className={`relative inline-block w-8 h-4 rounded-full transition-colors ${
          value ? "bg-white/40" : "bg-gray-300"
        }`}
      >
        <span
          className={`absolute top-0.5 left-0.5 w-3 h-3 rounded-full bg-white shadow transition-transform ${
            value ? "translate-x-4" : "translate-x-0"
          }`}
        />
      </span>
    </button>
  );
};

export default ProspectsToggle;
